import script from "./AdminDocumentEditorView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDocumentEditorView.vue?vue&type=script&setup=true&lang=js"

import "./AdminDocumentEditorView.vue?vue&type=style&index=0&id=07e8a130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e8a130"]])

export default __exports__